import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RelatedDocument } from '../related-doc/related-doc.model';

@Component({
  selector: 'similar-docs',
  templateUrl: './similar-docs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./similar-docs.component.css'],
})
export class SimilarDocsComponent implements OnInit {
  @Input() similarDocuments: RelatedDocument[];

  constructor() {}

  ngOnInit(): void {
    this.similarDocuments = this.similarDocuments.filter(
      (doc) => doc.documentType.name !== 'BIG5_SECTION'
    );
  }
}
